function parse(text, caret_position, parse_character) {
  for (var context = {}, value = "", focused_input_character_index = 0, index = 0; index < text.length; ) {
    var character = parse_character(text[index], value, context);
    character !== void 0 && (value += character, caret_position !== void 0 && (caret_position === index ? focused_input_character_index = value.length - 1 : caret_position > index && (focused_input_character_index = value.length))), index++;
  }
  caret_position === void 0 && (focused_input_character_index = value.length);
  var result = {
    value,
    caret: focused_input_character_index
  };
  return result;
}
export {
  parse as default
};
//# sourceMappingURL=parse.js.map
